export const calculateFutureTimestamp = ({ minutes, seconds }: { minutes?: number
	seconds?: number }): number => {
	return Date.now() + ((minutes || 0) * 60000) + ((seconds || 0) * 1000)
}
